export const UserAvatar: Record<string, any> = {
  "1": require("../assets/img/avatars/1.png"),
  "2": require("../assets/img/avatars/2.png"),
  "3": require("../assets/img/avatars/3.png"),
  "4": require("../assets/img/avatars/4.png"),
  "5": require("../assets/img/avatars/5.png"),
  "6": require("../assets/img/avatars/6.png"),
  "7": require("../assets/img/avatars/7.png"),
  "8": require("../assets/img/avatars/8.png"),
  "9": require("../assets/img/avatars/9.png"),
  "10": require("../assets/img/avatars/10.png"),
  "11": require("../assets/img/avatars/11.png"),
  "12": require("../assets/img/avatars/12.png"),
  "13": require("../assets/img/avatars/13.png"),
  "14": require("../assets/img/avatars/14.png"),
  "15": require("../assets/img/avatars/15.png"),
  "16": require("../assets/img/avatars/16.png"),
  "17": require("../assets/img/avatars/17.png"),
  "18": require("../assets/img/avatars/18.png"),
  "19": require("../assets/img/avatars/19.png"),
  "20": require("../assets/img/avatars/20.png"),
  "21": require("../assets/img/avatars/21.png"),
};
